import { connect } from 'react-redux';
import MatchEventForm from './MatchEventForm';
import State from '../../../../models';

const mapStateToProps = ({ calendar: { loading } }: State) => ({
  loading,
});

export default connect(mapStateToProps)(MatchEventForm);
